
function getInputs(){
  // obtener inputs que tengan cantidad mayor a 0
  var elementos = $('.input-bundle-quantity').filter(function () {
    return parseInt($(this).val(), 10) > 0;
  });
  return elementos;
}

function clearAll() {
  $('.product-item').removeClass('active');
  $('.input-bundle-quantity').val(0);
  $('.bundle-quantity-wrapper').addClass('visibility-hidden');

  // CHANGE TOOLBAR QTY TEXT
  var quantity_sum = getQtySum();
  $(".js-added-products").text(quantity_sum);

  $("#add-bundle-to-cart").prop("disabled", true);
}

function hideControls(that) {
  that.parents('.product-item').removeClass('active');
  that.parents('.product-item').find('.input-bundle-quantity').val(0);
  that.parents('.bundle-quantity-wrapper').addClass('visibility-hidden');

  // CHANGE TOOLBAR QTY TEXT
  var quantity_sum = getQtySum();
  $(".js-added-products").text(quantity_sum);

  $("#add-bundle-to-cart").prop("disabled", true);
}

function getSum(total, num) {
  return total + Math.round(num);
}

function getQtySum(){
 // convertir arreglo de elementos a valores
 var value_array = $.map(getInputs(), function (val, i) { return parseInt($(val).val()) })
 // sumar el total de cantidades

 var quantity_sum = value_array.reduce(getSum, 0);
 return quantity_sum;
}

$('.js-add-product').click(function () {
  $(this).parent().siblings().find('.input-bundle-quantity').val(1).trigger('change');
});

$('.js-remove-product').click(function() {
  hideControls($(this));
})

$(document).on("click", ".product-item .input-number-increment", function (e) {
  var quantity = $(this).parent().find("input").val();
  $(this).parent().find("input").val(parseInt(quantity) + 1).change();
});

$(document).on("click", ".product-item .input-number-decrement", function (e) {
  var quantity = $(this).parent().find("input").val();
  if (quantity <= 1) {
    hideControls($(this));
  }
  else{
    $(this).parent().find("input").val(parseInt(quantity) - 1).change();
  }
});

$('.input-bundle-quantity').on('change', function (e) {
  var $this = $(this),
    quantity_sum = getQtySum();

  if (quantity_sum > window.bundle.limit && window.bundle.limit != undefined) {
    $this.val($this.val() - 1)
    product_limit
    $('#product_limit').addClass("show");
    setTimeout(function() {
      $('#product_limit').removeClass("show");
    }, 4500);
    return false;
  }

  // QTY is less than limit
  $this.parents('.product-item').addClass('active');
  $this.parents('.bundle-quantity-wrapper').removeClass('visibility-hidden');
  
  // CHANGE TOOLBAR QTY TEXT
  $(".js-added-products").text(quantity_sum);
  $("#add-bundle-to-cart").prop("disabled", true);

  if (quantity_sum == window.bundle.limit || window.bundle.limit === undefined) {
    $("#add-bundle-to-cart").prop("disabled", false);
  }
});

$('#add-bundle-to-cart').click(function (e) {
  // $(this).attr('disabled', true);
  var items = [];

  getInputs().each(function (index, item) {
    items.push({
      id: $(item).data('id'),
      quantity: $(item).val(),
      selling_plan: $(this).data('selling-plan'),
      properties: {
        "type": "{{ collection.title | escape }}",
        "_compare_at_price": $(this).data('compare-at-price')
      }
    })
  });

  CartJS.addItems(items, {
    // Define a success callback to display a success message.
    "success": function (data, textStatus, jqXHR) {
      clearAll()
      //document.querySelector('#modal-cart').classList.add('show');
    },
    // Define an error callback to display an error message.
    "error": function (jqXHR, textStatus, errorThrown) {
      console.log("ERROR:", jqXHR.responseJSON.description)
    }
  });
})



